import {
  PayoutSettings,
  PayoutSettingsStandardDestination,
  PreferredPayoutSpeed
} from "@wingspanhq/wingspan-api-sdk";

export const selectorPayoutSettingsDefaultDestination = (
  payoutSettings: PayoutSettings
): PayoutSettingsStandardDestination | null | undefined =>
  payoutSettings.preferredPayoutSpeed === PreferredPayoutSpeed.INSTANT
    ? payoutSettings.instantDestination
    : payoutSettings.standardDestination;
